import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { IRole } from '../interfaces/role.interface';
import { RoleEnum } from '../enums/role.enum';

@Injectable({
  providedIn: 'root'
})
export class ClubAdminGuard implements CanActivate {
  constructor(private authService: AuthService) {
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.checkIsSuperAdmin(this.authService.user.role);
  }

  private checkIsSuperAdmin(role: IRole | string): boolean {
    if (typeof role === 'string') {
      return role === RoleEnum.CLUB_ADMIN;
    } else {
      return role.key === RoleEnum.CLUB_ADMIN;
    }
  }
}
